export default __webpack_public_path__ + "static/media/shubhra.9d250c1b.png";